import React from "react";
import styled from "styled-components";

const NavWrapper = styled.nav`
  position: sticky;
  top: 0;
  background: var(--hhb-primary); /* Habitat Blue */
  z-index: 10;
  padding: 10px 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 0;
    padding: 0;

    @media (max-width: 768px) {
      gap: 10px;
    }
  }

  li {
    font-size: var(--font-size-body);
    font-weight: 500;

    a {
      color: var(--hhb-white); /* White text */
      text-decoration: none;
      transition: color 0.3s ease;

      &:hover {
        color: var(--hhb-yellow); /* Yellow on hover */
      }
    }
  }
`;

const scrollToSection = (id) => {
  const section = document.querySelector(id);
  if (section) {
    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

const CustomNav = () => (
  <NavWrapper>
    <ul>
      <li>
        <a
          href="#history"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#history");
          }}
        >
          History
        </a>
      </li>
      {/* <li>
        <a
          href="#events"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#events");
          }}
        >
          Events
        </a>
      </li> */}
      <li>
        <a
          href="#campaign"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#campaign");
          }}
        >
          Campaign
        </a>
      </li>
      {/* <li>
        <a
          href="#sponsors"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#sponsors");
          }}
        >
          Sponsors
        </a>
      </li>
      <li>
        <a
          href="#cta"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#cta");
          }}
        >
          Get Involved
        </a>
      </li> */}
    </ul>
  </NavWrapper>
);

export default CustomNav;
